/*
loading: false,
        responseBody: (action.type) ? action : action.payload.error,
        error: action.payload.message,
        errorObject:action.payload
        */

        import DataModel from './dataModel';
 
        class GoogleAnalyticsModel extends DataModel{
                    constructor(report){
                        super(report);
                        this.api = "Adwords";
                        
                         
                        for (var ks of Object.keys(report)){
                            if (this[ks.toLowerCase() + "Report"]){
                            
                                this[ks.toLowerCase() + "Report"](report[ks]);
                            }
                        }
                         
                         
                        
                }
        
                  
                    
                      
                    queriesReport(obj){

                    }

                    metricsReport(obj){
                        this.metrics = obj;
                    }
                   
        
                
                }
        export default GoogleAnalyticsModel;
                  
        
        